import { useApp } from '@boozt/app/context';
import { renderReactLegacy } from '@boozt/helper';
import { PageHeaderStandalone } from '@common/Navigation/containers/PageHeader';

import './Navigation.scss';

export default function Navigation() {
    const { props, page, context } = useApp();
    const { pageHeaderStandalone } = props;
    const { navigation: genderMenu, navigationPath: uuids } = page;

    return (
        <div className="navigation-legacy">
            {
                renderReactLegacy(PageHeaderStandalone, context, {
                    ...pageHeaderStandalone,
                    genderMenu,
                    uuids,
                })
            }
        </div>
    );
}
